import React from 'react';
import {
        Show,
        ShowButton,
        Tab,
        TabbedShowLayout,
        DateField,
        List,
        Edit,
        Create,
        Datagrid,
        TextField,
        EditButton,
        ReferenceManyField,
        SingleFieldList,
        ChipField,
        SimpleForm,
        TextInput,
} from 'react-admin';

import LinkAnyFieldButton from './LinkAnyFieldButton';


export const ClientList = props => (
    <List {...props} >
        <Datagrid>
            <TextField source="name" />
            <TextField source="owner" />
            <ReferenceManyField label="Scopes" reference="ClientScopeView" target="clientId" linkType="none" >
                <SingleFieldList linkType={false} >
                    <LinkAnyFieldButton to="/Scope/:scopeId/show">
                        <ChipField source="scopeName" />
                    </LinkAnyFieldButton>
                </SingleFieldList>
             </ReferenceManyField>
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const ClientTitle = ({ record }) => {
    return <span>Client: {record ? `${record.name}` : ''}</span>;
};

export const ClientEdit = props => (
    <Edit title={<ClientTitle />} {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="name" />
            <TextInput source="owner" />
            <TextInput source="secret" />
            <TextInput source="key" />
        </SimpleForm>
    </Edit>
);

export const ClientCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="owner" />
            <TextInput source="secret" />
            <TextInput source="key" />
        </SimpleForm>
    </Create>
);

export const ClientShow = props => (
    <Show title={<ClientTitle />} {...props}>
        <TabbedShowLayout>
            <Tab label="summary" >
                <TextField source="name" />
                <TextField source="owner" />
                <TextField source="secret" />
                <TextField source="key" />
                <DateField label="Publication date" source="createdAt" />
            </Tab>
            <Tab label="Usage" >
                <ReferenceManyField label="Idp" reference="ClientIdpView" target="clientId" linkType={false} >
                    <SingleFieldList linkType={false} >
                         <LinkAnyFieldButton to="/Idp/:idpId/show">
                            <ChipField source="idpName" />
                         </LinkAnyFieldButton>
                     </SingleFieldList>
                </ReferenceManyField>
                <ReferenceManyField label="Scopes" reference="ClientScopeView" target="clientId" linkType={false} >
                    <SingleFieldList linkType={false} >
                         <LinkAnyFieldButton to="/Scope/:scopeId/show">
                            <ChipField source="scopeName" />
                         </LinkAnyFieldButton>
                     </SingleFieldList>
                </ReferenceManyField>
            </Tab>
        </TabbedShowLayout>
    </Show>
);
